import { render, staticRenderFns } from "./NestingCalculator.vue?vue&type=template&id=28c3158f&"
import script from "./NestingCalculator.vue?vue&type=script&lang=js&"
export * from "./NestingCalculator.vue?vue&type=script&lang=js&"
import style0 from "./NestingCalculator.vue?vue&type=style&index=0&id=28c3158f&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports